import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cookie-warner',
  templateUrl: './cookie-warner.component.html',
  styleUrls: ['./cookie-warner.component.css'],
})
export class CookieWarnerComponent implements OnInit {

  constructor(private cookieService : CookieService) { }

  private accepted : boolean;

  ngOnInit() {
    this.accepted = this.cookieService.check('cookie-warner-accepted');
  }

  accept() {
    this.cookieService.set('cookie-warner-accepted', 'true', 30, '/', window.location.hostname, false, 'Lax');
    this.accepted = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/cookie-warner/cookie-warner.component.ts